import LinkWrapper from 'components/Common/LinkWrapper';
import Svg from 'UI/components/Svg';
import cn from 'classnames';
import styles from './styles.module.scss';

export const NavItem = ({
  icon,
  title,
  description,
  path,
  className,
}) => (
  <LinkWrapper
    isLocalLink
    path={path}
    className={cn(styles.navItem, className)}
  >
    {icon && (
      <Svg
        type={icon}
        className={styles.icons}
        id={`icon-${icon}`}
      />
    )}
    <span>
      <span className={styles.title}>{title}</span>
      <span className={styles.description}>{description}</span>
    </span>
  </LinkWrapper>
);
